import { render, staticRenderFns } from "./Span.vue?vue&type=template&id=4a886bfa&"
import script from "./Span.vue?vue&type=script&lang=js&"
export * from "./Span.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports